import React from 'react';
import { Home } from "../../home/Home";


const MainAdminPage = () => {
  return (
	<Home/>
  );
};

export default MainAdminPage;